import {Tr} from "@/i18n/i18n";
import {BankOption} from "@/store/shop/types";
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {OfferType, Player, UserSource} from "@/store/player/types";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "../utils/c-u";
import {AbstractShopBankPanel} from "@/scenes.ui/abstract-shop-bank-panel";

export class ShopBankPanel extends AbstractShopBankPanel {

    constructor(scene: Phaser.Scene, x: number, y: number, bo: BankOption, player: Player, userSource: UserSource, callback: () => void, isReward: boolean = false, productPriceView: string | undefined = undefined, showBonuses: boolean = true) {
        super(scene, x, y, bo, player, userSource, callback, isReward, productPriceView);

        if (bo.gems === 79990) {
            bo.gems = 80000;
        } else if (bo.gems === 99990) {
            bo.gems = 100000;
        } else if (bo.gems === 199990) {
            bo.gems = 200000;
        } else if (bo.gems === 499990) {
            bo.gems = 500000;
        }

        if (bo.bonus === 100010) {
            bo.bonus = 100000;
        } else if (bo.bonus === 150010) {
            bo.bonus = 150000;
        } else if (bo.bonus === 400010) {
            bo.bonus = 400000;
        } else if (bo.bonus === 4500010) {
            bo.bonus = 4500000;
        }

        const image = SpriteUtils.addImage(this.scene, 60, this.getHeight(bo.decorationId) / 2 - 4, Keys.ATLAS_BANK, bo.imageId, 0.8).setOrigin(0.5, 0.5);

        const titleLight = SpriteUtils.addImage(this.scene, 140 - bo.title.length * 5, 15, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_LIGHT).setOrigin(0, 0);
        SpriteUtils.setDispSize(titleLight, 360 / 14 * bo.title.length * CU.S, 65 * CU.S);

        let titleText = TextUtils.addTextAdvanced(scene, bo.title.toUpperCase(), 125, 50,
            '#FBD777', 19, 'normal', 450, 'left', 2, Fonts.BENGALY_NORMAL);
        titleText.setStroke('#8c4f19', 5);

        let countText = TextUtils.addTextAdvanced(scene, String(bo.gems), 125, this.getGemsCountLinePosY(),
            '#9a9a98', 18, 'normal', 320, 'left', 1, Fonts.GOTHIC_DEUTSCH);
        countText.setOrigin(0, 0).setStroke('#000000', 1);
        let countIcon = SpriteUtils.addSprite(this.scene!, countText.getRightCenter().x! / CU.S + 1, this.getGemsCountLinePosY() - 5, Keys.IMG_RES_GEM_NO_SHADOW)
            .setOrigin(0, 0);
        SpriteUtils.setDispSize(countIcon, 34 * CU.S, 34 * CU.S);

        this.add([image, titleLight, titleText, countIcon, countText]);

        if (showBonuses && player.offers) {
            for (let offer of player.offers) {
                if (offer.offerType == OfferType.GEMS_X2) {
                    let campaignText1 = TextUtils.addTextAdvanced(scene, String('+' + bo.gems), 125, this.getOfferLinePosY(),
                        '#ACEC69', 12, 'normal', 320, 'left', 1, Fonts.GOTHIC_DEUTSCH);
                    let campGemIcon = SpriteUtils.addSprite(this.scene!, campaignText1.getRightCenter().x! / CU.S + 1, this.getOfferLinePosY() - 12, Keys.IMG_RES_GEM_NO_SHADOW)
                        .setOrigin(0, 0);
                    SpriteUtils.setDispSize(campGemIcon, 24 * CU.S, 24 * CU.S);
                    let campaignText2 = TextUtils.addTextAdvanced(scene, Tr('po.aktsii'), campGemIcon.getRightCenter().x! / CU.S + 3, this.getOfferLinePosY(),
                        '#ACEC69', 12, 'normal', 320, 'left', 1, Fonts.BENGALY_NORMAL);
                    this.add([campaignText1, campGemIcon, campaignText2]);
                }
            }
        }

        if (bo.bonus > 0) {
            let bonusText = TextUtils.addTextAdvanced(scene, ' + ' + String(bo.bonus), countIcon.getRightCenter().x! / CU.S + 2,
                this.getGemsCountLinePosY(),
                '#8bb37d', 18, 'normal', 320, 'left', 1, Fonts.GOTHIC_DEUTSCH);
            bonusText.setOrigin(0, 0).setStroke('#000000', 1);
            let bonusIcon = SpriteUtils.addSprite(this.scene!, bonusText.getRightCenter().x! / CU.S + 1, this.getGemsCountLinePosY() - 5, Keys.IMG_RES_GEM_NO_SHADOW)
                .setOrigin(0, 0);
            SpriteUtils.setDispSize(bonusIcon, 34 * CU.S, 34 * CU.S);

            this.add([bonusText, bonusIcon]);
        }
    }

    protected getBackKey(decorationId: string) {
        return Keys.UI_SHOP_PANEL_BACK;
    }

    protected getHeight(decorationId: string) {
        return ShopBankPanel.HEIGHT;
    }

    protected getGemsCountLinePosY() {
        return 75;
    }

    protected getOfferLinePosY() {
        return 120;
    }
}
